import { render } from "./FiltersDrawer.vue?vue&type=template&id=38f7c93a&scoped=true"
import script from "./FiltersDrawer.vue?vue&type=script&lang=js"
export * from "./FiltersDrawer.vue?vue&type=script&lang=js"

import "./FiltersDrawer.vue?vue&type=style&index=0&id=38f7c93a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f7c93a"]])

export default __exports__